import { render, staticRenderFns } from "./Table-Consultora.vue?vue&type=template&id=ca388b10&"
import script from "./Table-Consultora.vue?vue&type=script&lang=js&"
export * from "./Table-Consultora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports